const KeyboardBackspace = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960" 
            fill={color}
        >
            <path d="M360-200 120-440l240-240 56 56-184 184 184 184-56 56Z" />
        </svg>
    )
}

export default KeyboardBackspace; 